import React from "react";
import { useNavigate } from "react-router-dom";
import { happeningNowLinks, sendThroughLogin } from "../../helper/happeningNow";

// The buttons on a happening-now feed card: live results first (filled), then
// competitor lists and schedule (outlined). btnClass is the card's own button
// class (web-btn on the wide card, mob-register-btn on the narrow one).
const NowLinks = ({ event, btnClass }) => {
  const navigate = useNavigate();
  const open = (link) => {
    if (link.href) window.open(link.href, "_blank", "noopener,noreferrer");
    else if (link.login && !localStorage.getItem("accessToken")) sendThroughLogin(event, link, navigate);
    else navigate(link.to, { state: { event, from: "result" } });
  };
  return (
    <div className="feed-now-links" onClick={(e) => e.stopPropagation()}>
      {happeningNowLinks(event).map((link, i) => (
        <button key={link.key} type="button" className={`${btnClass} ${i ? "ghost" : "filled"}`} onClick={() => open(link)}>
          {i === 0 ? "Live results" : link.label}
        </button>
      ))}
    </div>
  );
};

export default NowLinks;
